export default __webpack_public_path__ + "static/media/020-Yorkshire Terrier.fd2eace0.svg";